import { React } from 'react'

export default function ToggleSwitch({ isChecked, onChange }) {
    return (
        <label className="toggle-switch">
            <input type="checkbox" checked={isChecked} onChange={e => onChange(e.target.checked)} />
            <span className="switch" />
        </label>
    );
}